import { Freight } from "../interfaces/model/freight.interface";
import { FreightResponse } from "../interfaces/response/freight-response.interface";

export class FreightMapper {
  static mapToFreight(response: FreightResponse[]): Freight[] {
    return response.map((freight) => ({
      name: freight.name,
      value: freight.value,
      businessDays: freight.business_days,
      deliveryMethodId: freight.delivery_method_id}));
  }
}
